/*
* Edit Client view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Modal, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import Auth from '../auth/auth';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import * as LK from '../config/apilookupkeys';
import { AuthConfig } from '../config/authconfiguration';
import { countriesList, statesList } from '../config/geolocations';
import * as ReduxQueries from '../queries';

import { ClientContacts } from './detail-form/client-contacts';
import { ClientDetails } from './detail-form/client-details';
import { ClientDetailsLocation } from './detail-form/client-details-location';
import { ClientNotes } from './detail-form/client-notes';
import { ClientPhoneNumbers } from './detail-form/client-phone-numbers';

import 'react-dropdown/style.css';
import '../inventory/detail-form/detail-form.css';

export interface IEditClientProps extends AppComp.IAppComponentProps {
    clientId?: any;
    client?: any;
    updateClient?: any;
    updateClientContact?: any;
    navigateTo?: any;
    lookups?: any;
}

export interface IEditClientState extends AppComp.IAppComponentState {
    // client: any;
    // clientContacts: any;
    formChanges?: any;
    contactToEdit?: any;
}

class EditClient extends AppComp.AppComponent<IEditClientProps, IEditClientState> {
    public originalFormDataCache = {};

    public constructor(props: IEditClientProps) {
        super(props, 'app.client-edit.');

        this.state = {
            formChanges: {},
            contactToEdit: {},
        };
    }

    public componentDidUpdate() {
        let resetFormData = this.getFormChangesResetRequired();
        if (resetFormData && _.size(this.state.formChanges)) {
            this.setState({ formChanges: {} });
        }
    }

    // Data transforms
    public extendClientData(record: any) {
        if (!record) { return; }

        let result = _.cloneDeep(record);

        return result;
    }

    // Handlers
    public handleSaveButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { client: _.pick(this.props.client, ['clientId', '_id']) },
            this.state.formChanges
        );

        this.props.updateClient(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                // this.originalFormDataCache = {};
                // this.setState({ formChanges: {} });

                const updClientDoc = _.get(response, 'body.client.document');
                const updClientDocContacts = _.get(updClientDoc, 'document.contacts', []);
                const newClientContactId = Formatters.getInt(_.last(updClientDocContacts), 'contactId');

                let auth = new Auth();
                const lsRedirectToAddBid = Formatters.bool(auth.getLocalStorageValue(AuthConfig.LocalStorageTokens.redirectToAddBid));

                if (lsRedirectToAddBid) {
                    auth.setLocalStorageValue(AuthConfig.LocalStorageTokens.redirectToAddBidNewClientContactId, newClientContactId);
                    this.props.navigateTo(NavigationLinks.orderAddBid());
                } else {
                    this.props.navigateTo(NavigationLinks.clientDetail(this.props.clientId));
                }
            } else {
                // Error during creation...
            }
        });
    }

    public handleFormInputChange(e: any, x: any) {
        // console.log('handleForminputchange', {e: e, x: x });

        const getChangesResult = this.getFormChanges(e, x);
        // console.log('handleForminputchange getChangesResult', {getChangesResult: getChangesResult, e: e, x: x });
        if (getChangesResult.applyChanges) {
            this.setState({
                formChanges: getChangesResult.formChanges
            });
        }
    }

    public handleFormSubmit(e: any) {
        // console.log('handleFormSubmit', e);
    }

    public handleEditButton(e: any, contact: any) {
        this.setState({
            contactToEdit: contact,
        });
    }

    public handleCancelEditContact() {
        this.setState({
            contactToEdit: {}
        });
    }

    public handleSaveEditContact() {
        const token = _.get(this.props, 'authsession.access_token', '');

        const updatedContact = {
            contactId: _.get(this.state.contactToEdit, 'contactId'),
            email: _.get(this.state.contactToEdit, 'email'),
            firstName: _.get(this.state.contactToEdit, 'firstName'),
            inactive: _.get(this.state.contactToEdit, 'inactive', false),
            lastName: _.get(this.state.contactToEdit, 'lastName'),
            notes: _.get(this.state.contactToEdit, 'notes'),
            phone: _.get(this.state.contactToEdit, 'phone'),
            salutation: _.get(this.state.contactToEdit, 'salutation'),
            title: _.get(this.state.contactToEdit, 'title'),
        };

        this.props.updateClientContact(parseInt(_.get(this.props.client, 'clientId'), 10), updatedContact, token, false).then(response => {
            this.setState({ contactToEdit: {} });
            if (response.status >= 200 && response.status < 300) {
                this.props.navigateTo(NavigationLinks.clientDetail(this.props.clientId));
            } else {
                console.error('Failed to update contact');
            }
        });
    }

    public renderEditContactModal(formData: any) {
        return (
            <Modal enforceFocus={true} show={!(_.isEmpty(this.state.contactToEdit))}>
                <Modal.Header closeButton={false}>
                    <Modal.Title>Edit Contact</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="clientContactsEdit.salutation"
                        label={this.appText('contact-salutation')}
                        labelKey="text"
                        valueKey="value"
                        required={true}
                        value={Formatters.getStr(this.state.contactToEdit, 'salutation')}
                        options={formData.options.salutationTypes}
                        onChange={(o) => { this.setState({ contactToEdit: _.merge({}, this.state.contactToEdit, { salutation: o.value }) }); }}
                    />

                    <KendoWrappers.KendoTextInputDebounced
                        name="clientContactsEdit.firstName"
                        label={this.appText('contact-firstname')}
                        placeholder={this.appText('contact-firstname.placeholder')}
                        value={Formatters.getStr(this.state.contactToEdit, 'firstName')}
                        required={true}
                        handleChange={(e) => { this.setState({ contactToEdit: _.merge({}, this.state.contactToEdit, { firstName: e.target.value }) }); }}
                    />

                    <KendoWrappers.KendoTextInputDebounced
                        name="clientContactsEdit.lastName"
                        label={this.appText('contact-lastname')}
                        placeholder={this.appText('contact-lastname.placeholder')}
                        required={true}
                        value={Formatters.getStr(this.state.contactToEdit, 'lastName')}
                        handleChange={(e) => { this.setState({ contactToEdit: _.merge({}, this.state.contactToEdit, { lastName: e.target.value }) }); }}
                    />

                    <KendoWrappers.KendoTextInputDebounced
                        name="clientContactsEdit.title"
                        label={this.appText('contact-title')}
                        placeholder={this.appText('contact-title.placeholder')}
                        required={false}
                        value={Formatters.getStr(this.state.contactToEdit, 'title')}
                        handleChange={(e) => { this.setState({ contactToEdit: _.merge({}, this.state.contactToEdit, { title: e.target.value }) }); }}
                    />

                    <KendoWrappers.KendoTextInputDebounced
                        name="clientContactsEdit.phone"
                        label={this.appText('contact-phone')}
                        value={Formatters.getStr(this.state.contactToEdit, 'phone')}
                        handleChange={(e) => { this.setState({ contactToEdit: _.merge({}, this.state.contactToEdit, { phone: e.target.value }) }); }}
                    />

                    <KendoWrappers.KendoTextInputDebounced
                        name="clientContactsEdit.email"
                        label={this.appText('contact-email')}
                        value={Formatters.getStr(this.state.contactToEdit, 'email')}
                        handleChange={(e) => { this.setState({ contactToEdit: _.merge({}, this.state.contactToEdit, { email: e.target.value }) }); }}
                    />

                    {/*TODO: Not working at the moment, add it back Soon(TM)*/}
                    {/* <KendoWrappers.KendoTextareaDebounced
                        name="clientContactsEdit.notes"
                        rows={4}
                        label={this.appText('contact-notes')}
                        value={Formatters.getStr(this.state.contactToEdit, 'notes')}
                        handleChange={(e) => { this.setState({contactToEdit: _.merge({}, this.state.contactToEdit, {notes: e.target.value}) });}}
                    />   */}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => this.handleSaveEditContact()}>{this.appTextCommon('buttons.save')}</Button>
                    <Button onClick={() => this.handleCancelEditContact()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    // Helpers
    public getFormChanges(e: any, x: any) {
        let result = {
            applyChanges: false,
            formChanges: {},
            formChangesResult: {},
        };

        let fieldName = '';
        let newValue;

        let formChangesCopy = _.cloneDeep(this.state.formChanges);

        if (_.get(e, 'target.props.name')) {
            // Kendo form element
            if (_.has(e, 'target.combobox')) {
                // combobox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'target.value');
            } else {
                // assume textbox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'value');
            }
        } else {
            const eventTargetType = _.get(e, 'target.type', '');

            switch (eventTargetType) {
                case 'textarea':
                case 'text':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                case 'kendo-dropdownlist':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value', '');
                    break;

                case 'virtualized-select':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(x, 'value');
                    break;

                case 'delete-button':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                default:
                    // console.log(`*** handleFormInputChange switch hit default for eventTargetType ${eventTargetType}`);
                    break;
            }
        }

        // console.log(`handleFormInputChange continuing 1 fieldName ${fieldName} newValue ${newValue}`, { e: e, x: x });

        if (!fieldName) { return result; }

        let applyChange = false;
        let origVal = _.get(this.originalFormDataCache, fieldName);
        let formChangesResult = {};

        // Special handling for delete-button case with clientContactsDelete
        if (_.get(e, 'target.type', '') === 'delete-button' && fieldName === 'clientContactsDelete') {
            const currentDeleteArray = _.get(formChangesCopy, fieldName, []);
            
            // If newValue is not already in the array, add it
            if (!_.includes(currentDeleteArray, newValue)) {
                currentDeleteArray.push(newValue);
                _.set(formChangesCopy, fieldName, _.cloneDeep(currentDeleteArray));
                _.set(formChangesResult, fieldName, _.cloneDeep(currentDeleteArray));
                applyChange = true;
            }
            
            if (applyChange) {
                result.applyChanges = true;
                result.formChanges = _.cloneDeep(formChangesCopy);
                result.formChangesResult = _.cloneDeep(formChangesResult);
            }
            
            return result;
        }

        if (_.isArray(origVal)) {
            if (_.isArray(newValue)) {
                if (!_.isEqual(origVal, newValue)) {
                    _.set(formChangesCopy, fieldName, _.cloneDeep(newValue));
                    _.set(formChangesResult, fieldName, _.cloneDeep(newValue));
                    applyChange = true;
                } else {
                    applyChange = false;
                }
            } else {
                if (_.includes(origVal, newValue)) {
                    // console.log(`original array already contained val ${newValue} origVal`, origVal);
                    applyChange = false;
                } else {
                    const formChangesArr = _.get(formChangesCopy, fieldName, []);
                    // console.log(`${fieldName} formChangesArr`, formChangesArr);
                    if (_.includes(formChangesArr, newValue)) {
                        // console.log(`formChangesArr field ${fieldName} array already contains val ${newValue} formChangesArr`, formChangesArr);
                        applyChange = false;
                    } else {
                        formChangesArr.push(newValue);
                        _.set(formChangesCopy, fieldName, _.cloneDeep(formChangesArr));
                        _.set(formChangesResult, fieldName, _.cloneDeep(formChangesArr));
                        applyChange = true;
                        // console.log(`formChangesArr field ${fieldName} array DID NOT have val ${newValue}, applying change`, formChangesArr);
                    }
                }
            }
        } else {
            if (String(newValue) !== String(origVal)) {
                // New value
                _.set(formChangesCopy, fieldName, newValue);
                _.set(formChangesResult, fieldName, newValue);
                applyChange = true;
            } else {
                // Same as orig val
                if (_.has(formChangesCopy, fieldName)) {
                    _.unset(formChangesCopy, fieldName);
                    _.set(formChangesResult, fieldName, newValue);
                    applyChange = true;
                }
            }
        }

        if (applyChange) {
            result.applyChanges = true;
            result.formChanges = _.cloneDeep(formChangesCopy);
            result.formChangesResult = _.cloneDeep(formChangesResult);
        }

        // console.log(`getFormChanges returns result`, result);

        return result;
    }

    public buildOptions(lookups: any, key: any, srcValueField: any = 'name', srcTextField: any = 'name') {
        const l = _.get(lookups, key, []);

        if (_.size(l) <= 0) { return []; }

        return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getStr(c, srcValueField), text: Formatters.getStr(c, srcTextField) })), 'value');
    }

    public buildOptionsIntValue(lookups: any, key: any, srcValueField: any = 'name', srcTextField: any = 'name') {
        const l = _.get(lookups, key, []);

        if (_.size(l) <= 0) { return []; }

        return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getInt(c, srcValueField), text: Formatters.getStr(c, srcTextField) })), 'value');
    }

    public buildOptionsGeolocations(l: Array<any> = [], srcValueField: any = 'name', srcTextField: any = 'name') {
        if (_.size(l) <= 0) { return []; }

        return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getStr(c, srcValueField), text: Formatters.getStr(c, srcTextField) })), 'value');
    }

    public buildOptionsClientContacts(l: Array<any> = [], srcValueField: any = 'contactId') {
        if (_.size(l) <= 0) { return []; }

        const mapped = l.map((c) => {
            const contactName = Formatters.composeClientContactFormal(c);
            return _.merge({}, { value: Formatters.getInt(c, srcValueField), text: contactName });
        });

        return _.orderBy(mapped, 'text');
    }

    public getFormData(clientIn: any, lookups: any) {
        const clientMerged = _.merge(clientIn, this.state.formChanges);

        let result = {
            clientId: Formatters.getInt(clientMerged, 'clientId'),

            clientType: {
                clientTypeId: Formatters.getInt(clientMerged, 'clientType.clientTypeId'),
            },

            location: {
                address1: Formatters.getStr(clientMerged, 'location.address1'),
                address2: Formatters.getStr(clientMerged, 'location.address2'),
                city: Formatters.getStr(clientMerged, 'location.city'),
                country: Formatters.getStr(clientMerged, 'location.country'),
                countryCode: Formatters.getStr(clientMerged, 'location.countryCode'),
                name: Formatters.getStr(clientMerged, 'location.name'),
                postalCode: Formatters.getStr(clientMerged, 'location.postalCode'),
                state: Formatters.getStr(clientMerged, 'location.state'),
                stateCode: Formatters.getStr(clientMerged, 'location.stateCode'),
            },

            region: {
                regionId: Formatters.getInt(clientMerged, 'region.regionId'),
            },

            fax: Formatters.getStr(clientMerged, 'fax'),
            phone: Formatters.getStr(clientMerged, 'phone'),
            inactive: _.get(clientMerged, 'inactive'),
            name: Formatters.getStr(clientMerged, 'name'),

            clientNotes: _.get(clientMerged, 'notes'),
            clientNotesAdd: Formatters.getStr(clientMerged, 'clientNotesAdd'),
            clientNotesDelete: _.get(clientMerged, 'clientNotesDelete'),

            clientContacts: _.get(clientMerged, 'contacts'),
            clientContactsDelete: _.get(clientMerged, 'clientContactsDelete'),

            options: {
                clientTypes: this.buildOptionsIntValue(lookups, LK.LookupKeys.ClientTypes, 'clientTypeId', 'name'),
                states: this.buildOptionsGeolocations(statesList, 'stateCode', 'name'),
                countries: this.buildOptionsGeolocations(countriesList, 'countryCode', 'name'),
                regions: this.buildOptionsIntValue(lookups, LK.LookupKeys.Regions, 'regionId', 'name'),
                salutationTypes: this.buildOptions(lookups, LK.LookupKeys.Salutations, 'salutation', 'salutation'),
            }
        };

        if (_.size(result.clientNotes)) {
            result.clientNotes = _.filter(result.clientNotes, (o) => Formatters.getStr(o, 'notes') !== '');
            if (_.size(result.clientNotes)) {
                result.clientNotes = _.orderBy(result.clientNotes, ['created'], ['desc']);
            }
        }

        if (_.size(result.clientNotesDelete)) {
            result.clientNotes = _.omitBy(result.clientNotes, (o) => _.includes(result.clientNotesDelete, o.objectId));
        }

        // if (_.size(result.clientContacts)) {
        //     result.clientContacts = _.filter(result.clientContacts, (o) => Formatters.getStr(o, 'contacts') !== '');
        //     if (_.size(result.clientNotes)) {
        //         result.clientNotes = _.orderBy(result.clientNotes, ['created'], ['desc']);
        //     }
        // }

        if (_.size(result.clientContactsDelete)) {
            result.clientContacts = _.omitBy(result.clientContacts, (o) => _.includes(result.clientContactsDelete, o.contactId));
        }

        return _.merge(result, this.state.formChanges);
    }

    public getFormChangesCount() {
        return _.size(this.state.formChanges);
    }

    public getFormChangesResetRequired() {
        let resetFormData = false;
        // Props values
        const pa = Formatters.getInt(this.props, 'clientId');

        // Cached values
        const ca = Formatters.getInt(this.originalFormDataCache, 'clientId');

        if (pa && ca) {
            resetFormData = (pa !== ca) ? true : false;
        }

        return resetFormData;
    }

    // Renderers
    public renderButtonToolbar = () => {
        let buttonProps = {
            bsSize: 'sm',
        };

        let saveChangesButtonProps = {
            bsStyle: 'default',
            bsSize: 'sm',
            disabled: true,
            title: this.appText('no-changes'),
        };

        if (this.getFormChangesCount()) {
            saveChangesButtonProps = {
                bsStyle: 'success',
                bsSize: 'sm',
                disabled: false,
                title: `${this.appText('save')} ${Formatters.plural(this.appText('change'), this.getFormChangesCount(), false)}`,
            };
        }

        return (
            <div>
                <Well>
                    <Row>
                        <Col xs={9}>
                            <ButtonToolbar>
                                <ButtonGroup>
                                    <Button {...saveChangesButtonProps} onClick={e => { this.handleSaveButton(e); }}><i className="glyphicon glyphicon-floppy-disk" /> {saveChangesButtonProps.title}</Button>
                                </ButtonGroup>
                            </ButtonToolbar>
                        </Col>
                        <Col xs={3} />
                    </Row>
                </Well>
            </div>
        );
    }

    public render() {
        const {
            clientId,
            lookups,
            ...rest
        } = this.props;

        const client = this.extendClientData(this.props.client);

        const pageTitle = this.appTextPageTitleAppendString(_.get(client, 'name', ''), 'page-title', true);
        let page = (<div />);
        if (Number(_.get(client, 'clientId', -1)) === Number(clientId)) {
            const formData = this.getFormData(client, lookups);

            /* console.log('pageData', {
                client: client,
                formData: formData,
                numChanges: this.getFormChangesCount(),
            }); */

            if (this.getFormChangesResetRequired() || !_.size(this.originalFormDataCache)) {
                this.originalFormDataCache = _.cloneDeep(formData);
            }

            page = (
                <div>
                    {this.renderButtonToolbar()}
                    {this.renderEditContactModal(formData)}

                    <WhiteBoxPageSection title="">
                        <KendoWrappers.KendoHorizontalForm>
                            <Row className="form-row">
                                <Col xs={7} xl={5}>
                                    <Row>
                                        <Col xs={12}>
                                            <ClientDetailsLocation
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 7 }}
                                                sectionTitle={this.appText('section-title.location')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12}>
                                            <ClientPhoneNumbers
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 7 }}
                                                sectionTitle={this.appText('section-title.phone-numbers')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12}>
                                            <ClientNotes
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveButton={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 7 }}
                                                sectionTitle={this.appText('section-title.client-notes')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={5} xl={7}>
                                    <Row>
                                        <Col xs={12}>
                                            <ClientDetails
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 7 }}
                                                sectionTitle={this.appText('section-title.details')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12}>
                                            <ClientContacts
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveButton={(e) => this.handleSaveButton(e)}
                                                handleEditButton={(e, o) => this.handleEditButton(e, o)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 4 }}
                                                sectionTitle={this.appText('section-title.contacts')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </KendoWrappers.KendoHorizontalForm>
                    </WhiteBoxPageSection>

                    {this.renderButtonToolbar()}
                </div>
            );
        }

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrlLookups = () => ApiEndpoints.getLookupsByKeyUrl([
    LK.LookupKeys.ClientTypes,
    LK.LookupKeys.Regions,
    LK.LookupKeys.Salutations,
]);

const getApiUrl = props => ApiEndpoints.getClientDetailUrl(props.match.params.clientId);

const mapPropsToConfigs = (props) => {
    return [
        ReduxQueries.Queries.getClientDetailRequest(
            getApiUrl(props),
            ReduxQueries.PropsAccessToken(props),
        ),

        ReduxQueries.Queries.getLookupsByKeyRequest(
            getApiUrlLookups(),
            ReduxQueries.PropsAccessToken(props)
        ),
    ];
};

const mapStateToProps = (state, props) => {
    const clientId = _.get(props, 'match.params.clientId', 0);

    const mapped = ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
        clientId: clientId,
        client: state.entities.clientDetailClient
    });

    return mapped;
};

const mapDispatchToProps = {
    updateClient: MutateActions.updateClientMutateAsync,
    updateClientContact: MutateActions.updateClientContactMutateAsync,
    navigateTo: (path) => push(path),
};

const EditClientContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(EditClient);

export default withRouter(EditClientContainer);



// WEBPACK FOOTER //
// ./src/client/edit.tsx